<template>
  <div class="data-field">
    <div class="user-panel">
      <div class="panel-header">
        <h3>{{ userInfos.first_name }} {{ userInfos.last_name }}</h3>
        <button
          class="save-button"
          :disabled="!changeInPage"
          @click="save_change"
        >
          Enregistrer
        </button>
      </div>
      <section class="row base-information">
        <div class="col">
          <div class="title-field">Adresse email</div>
          <div>{{ userInfos.email }}</div>
        </div>
        <div class="col">
          <div class="title-field">N° de téléphone</div>
          <div>{{ userInfos.phone_number }}</div>
        </div>
        <div class="col">
          <div class="title-field">Créé par un administrateur ?</div>
          <div>
            {{ userInfos.id_creator ? "Oui" : "Non" }}
          </div>
        </div>
      </section>
      <section class="row base-information">
        <div class="col">
          <div class="title-field">Date de création</div>
          <div>
            {{
              userInfos.created_at
                ? moment(userInfos.created_at).format("Do MMMM YYYY")
                : "Date inconnue"
            }}
          </div>
        </div>
        <div class="col">
          <div class="title-field">Date de mise à jour</div>
          <div>
            {{
              userInfos.updated_at
                ? moment(userInfos.updated_at).format("Do MMMM YYYY")
                : "date inconnue"
            }}
          </div>
        </div>
        <div class="col">
          <div class="title-field">Dernière connexion</div>
          <div>
            {{
              userInfos.last_connection
                ? moment(userInfos.last_connection).fromNow()
                : "date inconnue"
            }}
          </div>
        </div>
      </section>
      <h4>Role</h4>
      <section v-if="roles.length" class="role-section">
        <RoleTab
          :roles="roles"
          :userInfos="userInfos.id_role"
          @changerole="(id_role) => updateRole(id_role)"
        />
      </section>
      <h4>Produits</h4>
      <section class="products">
        <div
          class="product"
          v-for="product in products"
          v-bind:key="product.id_product"
        >
          <div class="product-header">
            <div class="">{{ product.product_name }}</div>
            <img
              v-if="product.app == 'DAP'"
              class="logo-product"
              src="https://agrivitech-logo.s3.eu-west-3.amazonaws.com/DAP.png"
            />
          </div>
          <div>
            <div style="font-weight: bold">Description :</div>
            <div>{{ product.description }}</div>
          </div>
          <div class="access-section">
            <div class="" style="font-weight: bold">
              Accès pour cet utilisateur ?
            </div>
            <ToggleAccess
              :userInfos="userInfos"
              :product="product"
              @updatedaccess="
                (active) => changeAccess(active, product.id_product)
              "
            />
          </div>
        </div>
      </section>
      <h4>Apps mobiles</h4>
      <section class="products">
        <div class="product" v-for="app in apps" v-bind:key="app.id_app">
          <div class="product-header align-items-center">
            <img
              class="logo-product"
              src="https://agrivitech-logo.s3.eu-west-3.amazonaws.com/Fleet.png"
            />
            <div class="">Accès Fleet</div>
            <div class="access-section">
              <ToggleAccessApps
                :userInfos="userInfos"
                :app="app"
                @updatedaccess="(active) => changeAccessApp(active, app.id_app)"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
import moment from "moment";
import AdminService from "../../services/AdminService";
import ToggleAccess from "../../components/LoggedComp/ToggleAccess.vue";
import ToggleAccessApps from "../../components/LoggedComp/ToggleAccessApps.vue";
import RoleTab from "../../components/LoggedComp/RoleTab.vue";
export default {
  components: {
    ToggleAccess,
    ToggleAccessApps,
    RoleTab,
  },
  emits: ["success"],
  setup(_props, { emit }) {
    const router = useRouter();
    const route = useRoute();

    const userInfos = ref({});
    const roles = ref([]);
    const products = ref([]);
    const apps = ref([]);

    const token = ref("");

    const baseRole = ref();
    const newRole = ref();

    const initialAccessState = ref([]);
    const newAccessState = ref([]);

    const initial_apps_state = ref([]);
    const new_apps_state = ref([]);

    const changeInPage = ref(false);

    const getData = async (token) => {
      const infos = await AdminService.user(route.params.id, token);
      const rolesList = await AdminService.allRoles(token);
      const productList = await AdminService.allProducts(token);
      const appList = await AdminService.allApps(token);
      console.table(appList.appList)
      console.table(userInfos.value.apps)
      if (infos == null) {
        localStorage.removeItem("token");
        router.push("/private");
      }
      userInfos.value = infos.user;

      const role = infos.user.id_role;
      baseRole.value = role;
      newRole.value = role;
      products.value = productList.appList;
      roles.value = rolesList.roleList; 
      apps.value = appList.appList;

      for (const prod of products.value) {
        // regarde si chaque produit est dans ceux accessible pour le user
        const hasAccess = userInfos.value.products.find(
          (a) => a.id_product == prod.id_product
        )
          ? true
          : false;
        initialAccessState.value.push([prod.id_product, hasAccess]);
      }
      newAccessState.value = JSON.parse(
        JSON.stringify(initialAccessState.value)
      );

      for (const app of apps.value) {
        // regarde si chaque apps est dans ceux accessible pour le user
        const hasAccess = userInfos.value.apps.find(
          (a) => a.id_app == app.id_app
        )
          ? true
          : false;
        initial_apps_state.value.push([app.id_app, hasAccess]);
      }
      new_apps_state.value = JSON.parse(
        JSON.stringify(initial_apps_state.value)
      );
    };
    onBeforeMount(async () => {
      token.value = localStorage.getItem("token");
      if (token.value == null || token.value.length == 0) {
        localStorage.removeItem("token");
        router.push("/private");
      }
      await getData(token.value);
    });

    const save_change = async () => {
      try {
        if (baseRole.value != newRole.value) {
          await AdminService.updateRole(
            userInfos.value.id_user,
            newRole.value,
            token.value
          );
        }
        if (
          JSON.stringify(newAccessState.value) !=
          JSON.stringify(initialAccessState.value)
        ) {
          const sendableArray = [];
          let i = 0;
          for (const state of newAccessState.value) {
            if (state[1] != initialAccessState.value[i][1]) {
              sendableArray.push(state);
            }
            i++;
          }
          await AdminService.manageProductForUser(
            userInfos.value.id_user,
            sendableArray,
            token.value
          );
        }
        // création de l'array à envoyer pour les apps 
        if (JSON.stringify(new_apps_state.value) !=
            JSON.stringify(initial_apps_state.value)
        ){
          const sendableArray = [];
          let i = 0;
          for (const state of new_apps_state.value) {
            if (state[1] != initial_apps_state.value[i][1]) {
              sendableArray.push(state);
            }
            i++;
          }
          await AdminService.manageAppForUser(
            userInfos.value.id_user,
            sendableArray,
            token.value
          );
        }
        initialAccessState.value = JSON.parse(
          JSON.stringify(newAccessState.value)
        );
        new_apps_state.value = JSON.parse(
          JSON.stringify(initial_apps_state.value)
        );
        baseRole.value = newRole.value;
        checkChanges();
        emit("success", "Les modifications ont bien été enregistré.");
      } catch (e) {
        emit("error", e.error);
      }
    };

    const checkChanges = () => {
      if (
        newRole.value != baseRole.value ||
        JSON.stringify(newAccessState.value) !=
          JSON.stringify(initialAccessState.value) ||
        JSON.stringify(new_apps_state.value) !=
          JSON.stringify(initial_apps_state.value)
      ) {
        changeInPage.value = true;
      } else {
        changeInPage.value = false;
      }
    };

    const changeAccess = (oui, id_product) => {
      newAccessState.value.find((prod) => {
        if (prod[0] == id_product) {
          prod[1] = oui;
          checkChanges();
        }
      });
    };

    const changeAccessApp = (oui, id_app) => {
      new_apps_state.value.find((app) => {
        if (app[0] == id_app) {
          app[1] = oui;
          checkChanges();
        }
      });
    };

    const updateRole = (id_role) => {
      newRole.value = id_role;
      checkChanges();
    };

    moment.locale("fr");
    return {
      moment,
      changeAccess,
      changeAccessApp,
      updateRole,
      save_change,
      userInfos,
      newRole,
      roles,
      products,
      apps,
      changeInPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-field {
  font-weight: 600;
  font-size: 1rem;
}
h4 {
  margin: 0;
  padding: 0;
}
.data-field {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .user-panel {
    // margin-bottom: 2em;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-radius: 5px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .panel-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      text-transform: capitalize;
      font-size: 17px;
      font-weight: 600;
      font-weight: 700;
      //   padding-top: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid black;
      h3 {
        margin: 0;
      }
      button {
        border: none;
        color: white;
        background-color: var(--mainBlue);
        text-transform: uppercase;
        padding-left: 1rem;
        padding-right: 1rem;
        transition: 0.2s all ease-in;
        font-size: 1rem;
        font-weight: 500;
      }
      button:disabled {
        background-color: black;
        opacity: 50%;
      }
    }
  }
  .data-table {
    margin-bottom: 2em;
    box-shadow: var(--box-shadow, 1px 1px 4px 0 rgba(0, 0, 0, 0.15));
    border-radius: 5px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    .table-title {
      font-size: 17px;
      margin-bottom: 1rem;
      font-weight: 700;
    }
    .table-header {
      font-weight: 600;
      background-color: #f2f2f2;
      padding-top: 0.25em;
      padding-bottom: 0.25em;
      padding-left: 1em;
      margin-left: -1rem;
      margin-right: -1rem;
    }
    .table-row {
      border-bottom: 1px solid #f2f2f2;
      padding-top: 0.75em;
      padding-bottom: 0.75em;
      padding-left: 1em;
      margin-left: -1rem;
      margin-right: -1rem;
      overflow: hidden;
      transition: all 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
      .user-cell {
        word-break: break-all;
        font-size: 13px;
      }
    }
  }
}
.products {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  .product {
    padding: 1rem;
    border: 1px solid #e9e9e9;
    border-radius: 3px;
    flex-grow: 1;
    max-width: 50%;
    .product-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-weight: 600;
      font-size: 1rem;
      .logo-product {
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
        border-radius: 50%;
        width: 50px;
        height: 50px;
      }
    }
    .access-section {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      margin-bottom: -0.5rem;
    }
  }
}
</style>
